<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="220px"
          :model="form"
          :rules="rules"
        >
        <!-- 选择终端 -->
        <el-form-item label="终端" prop="endpointId">
        <el-select
          v-model="form.endpointId"
          clearable
          placeholder="请选择终端"
          @change="getData"
        >
          <el-option
            v-for="item in endpointIdList"
            :key="item.endpointId"
            :label="item.title"
            :value="item.endpointId"
          ></el-option>
        </el-select>
      </el-form-item>
          <el-form-item label="appId" prop="appId">
            <el-input v-model.trim="form.appId" />
          </el-form-item>
          <el-form-item label="appSecret" prop="appSecret">
            <el-input v-model.trim="form.appSecret" show-password />
          </el-form-item>
          <el-form-item label="订单待支付提醒" prop="subscribeOrderPaying">
            <el-input v-model.trim="form.subscribeOrderPaying" />
          </el-form-item>
          <el-form-item label="订单确认通知" prop="subscribeOrderConfirm">
            <el-input v-model.trim="form.subscribeOrderConfirm" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getWechatConfig, setupWechatWidget,findEndpointList } from '@/api/settings'
import storejs from 'store'
export default {
  name: 'SettingsWeApp',
  data() {
    return {
      labelPosition: 'right',
      endpointIdList:[],
      form: {
        endpointId:'',
        appId: '',
        appSecret: '',
        subscribeOrderPaying: '',
        subscribeOrderConfirm: '',
      },
      rules: {
        // endpointId:[{ required: true, message: '请选择终端', trigger: 'blur' }],
        appId: [{ required: true, message: '请输入appId', trigger: 'blur' }],
        appSecret: [
          { required: true, message: '请输入appSecret', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.getEndpoint()
    this.getData()
  },
  methods: {
    async getEndpoint() {
      const ret = await findEndpointList({
        page: 1,
        size: 10000,
        clientAppId: storejs.get('appId')
      })
      this.endpointIdList = ret.list
    },
    async getData() {
      const ret = await getWechatConfig({
        name: 'widget',
        endpointId: this.form.endpointId
      })
      this.form.appId = ret&&ret.basic && ret.basic.appId
      this.form.appSecret = ret&&ret.basic && ret.basic.appSecret
      this.form.subscribeOrderPaying = ret&&ret.basic && ret.basic.subscribeOrderPaying
      this.form.subscribeOrderConfirm = ret&&ret.basic && ret.basic.subscribeOrderConfirm
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({},this.form)
          const endpointId = form.endpointId
          delete form.endpointId
          await setupWechatWidget({
            config: form,
            endpointId
          })
          this.getData()
          this.$message.success('保存微信小程序配置成功')
        } else {
          this.$message.success('保存微信小程序配置失败')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form-item__content {
    .el-rate {
      display: inline-block;
      font-size: 0;
      line-height: 1;
      vertical-align: middle;
    }

    .el-transfer__buttons {
      padding: 10px 10px 0 10px;
    }
  }
}
.title {
  color: #c3c3c3;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 10px;
}
</style>
